if (!customElements.get('neya-product-hub')) {
  customElements.define(
    'neya-product-hub',
    class NeyaProductHub extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(tab, true));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        const requestedTab = window.location.hash
          ? this.tabs.find((tab) => tab.dataset.hash === window.location.hash)
          : null;

        if (requestedTab) this.activate(requestedTab, false);
      }

      activate(selectedTab, shouldFocus) {
        const panelId = selectedTab.getAttribute('aria-controls');

        this.tabs.forEach((tab) => {
          const isSelected = tab === selectedTab;
          tab.setAttribute('aria-selected', String(isSelected));
          tab.tabIndex = isSelected ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== panelId;
        });

        selectedTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        if (shouldFocus) selectedTab.focus({ preventScroll: true });
      }

      onKeydown(event, currentIndex) {
        let nextIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        if (nextIndex === undefined) return;
        event.preventDefault();
        this.activate(this.tabs[nextIndex], true);
      }
    }
  );
}
